import { useCrudService } from 'framework/crud';
import { useFinanceApi } from 'infrastructure/api';
import { cloneDeep } from 'lodash';
import serviceCostsStructureValidation from './structure/Create/serviceCostsStructureValidation';
const BUDGETING_API_PATH = '/budgets';

export const BUDGETING_READ = 'READ';
export const BUDGETING_CREATE_STRUCTURE = 'SERVICE_MANAGEMENT_SERVICE_BUDGET_CREATE_STRUCTURE';

const useBudgetingService = () => {
  const singleResourceUrl = '/budgets/:id';
  const {
    search: baseSearch,
    create,
    getById,
    update,
  } = useCrudService({
    singleResourceUrl,
    listResourceUrl: BUDGETING_API_PATH,
    useService: useFinanceApi,
  });

  const singleStructureUrl = '/budgets/structures/:id';
  const {
    search: baseSearchStructure,
    create: baseCreateStructure,
    update: baseUpdateStructure,
  } = useCrudService({
    singleResourceUrl: singleStructureUrl,
    listResourceUrl: `${BUDGETING_API_PATH}/structures`,
    useService: useFinanceApi,
  });

  const { sendGetRequest } = useFinanceApi();

  const search = (request: any) => {
    const searchParams = cloneDeep(request);
    const searchString = searchParams.filter?.['specification:search']?.eq || '';

    if (searchString && searchParams.filter) {
      delete searchParams.filter?.['specification:search'];
      searchParams.filter.name = {
        ct: searchString,
      };
    }

    return baseSearch(searchParams);
  };

  const structureFormDataMapping = (data: any): any => {
    return {
      ...data,
      createdById: data.createdBy ?? '',
      timelineId: data.id,
      updatedById: data.updatedBy,
    };
  };

  const searchStructure = async (budgetId: string, request: any) => {
    const searchParams = cloneDeep(request);
    if (searchParams.filter) {
      searchParams.filter['budget.id'] = {
        eq: budgetId,
      };
    } else {
      searchParams.filter = {
        'budget.id': {
          eq: budgetId,
        },
      };
    }

    const result = await baseSearchStructure(searchParams);

    return {
      ...result,
      result: result.result.map(structureFormDataMapping),
    };
  };

  const createStructure = async (id: string, request: any) => {
    const params = cloneDeep(request);
    params.budgetId = id;
    params.categories = params.categories.map((item: { name: string }) => item.name);
    return baseCreateStructure(params);
  };

  const updateStructure = async (id: string, request: any) => {
    const params = cloneDeep(request);
    params.categories = params.categories.map((item: { name: string }) => item.name);
    return baseUpdateStructure(id, params);
  };

  const getActiveStructure = async (budgetId: string, date: string | null) => {
    try {
      const queryParam = date ? `?date=${date}` : '';
      const result = await sendGetRequest(`/budgets/structures/${budgetId}/active${queryParam}`);
      return result.json();
    } catch {
      return { error: 'Not Found.' };
    }
  };

  const getValidationSchema = () => Promise.resolve(serviceCostsStructureValidation);

  return {
    create,
    update,
    search,
    getById,
    getActiveStructure,
    searchStructure,
    createStructure,
    updateStructure,
    getValidationSchema,
  };
};

export default useBudgetingService;
